import { createFeature, createReducer } from '@ngrx/store';

// Simple state interface for data viewer
export interface DataViewerState {
  // Add your data viewer state properties here
  // For now, keeping it simple
}

// Initial state
export const initialState: DataViewerState = {
  // Initialize your state properties here
};

// Feature with automatic selector generation
export const dataViewerFeature = createFeature({
  name: 'dataViewer',
  reducer: createReducer(initialState)
});

// Export reducer for store config
export const dataViewerReducer = dataViewerFeature.reducer;
